window.addEventListener('load', () => {
    const skipButton = document.getElementById('skipToMainContent');
    const mainContent = document.querySelector('main[tabindex="-1"]');

    if (skipButton && mainContent) {
        skipButton.addEventListener('click', function() {
            mainContent.focus();
        });
    }
});
